function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var ByQuantity = /*#__PURE__*/function () {
  function ByQuantity(priceByQuantityEl, quantitySelectorForm) {
    var _this = this;
    _classCallCheck(this, ByQuantity);
    if (!priceByQuantityEl || !quantitySelectorForm) {
      return;
    }
    this.quantitySelectorEl = quantitySelectorForm.querySelector('.js-input-counter');
    if (!this.quantitySelectorEl) {
      return;
    }
    this.min = parseFloat(this.quantitySelectorEl.getAttribute('min') || this.quantitySelectorEl.dataset.min);
    this.max = parseFloat(this.quantitySelectorEl.getAttribute('max') || this.quantitySelectorEl.dataset.max);
    this.querySelectorButtonsEl = quantitySelectorForm.querySelectorAll('.js-quantity__buttons');
    this.quantitySelectorEl.addEventListener('input', function () {
      return _this.updateCheckbox();
    });
    var _iterator = _createForOfIteratorHelper(this.querySelectorButtonsEl),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var button = _step.value;
        button.addEventListener('click', function (e) {
          return setTimeout(function () {
            return _this.updateCheckbox();
          }, 25);
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    this.values = [];
    var optionsListEl = priceByQuantityEl.querySelector('.js-form-field-list');
    this.checkboxsEl = optionsListEl.querySelectorAll('.js-form-checkbox');
    var _iterator2 = _createForOfIteratorHelper(this.checkboxsEl),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var checkbox = _step2.value;
        checkbox.addEventListener('change', function (e) {
          return _this.updateFromCheckbox(e);
        });
        this.values.push(Number.parseInt(checkbox.value));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    this.updateCheckbox();
  }
  return _createClass(ByQuantity, [{
    key: "updateCheckbox",
    value: function updateCheckbox() {
      var closestValue = this._getClosestValue(Number.parseInt(this.quantitySelectorEl.value));
      var _iterator3 = _createForOfIteratorHelper(this.checkboxsEl),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var checkbox = _step3.value;
          checkbox.checked = false;
          if (closestValue && checkbox.value == closestValue) checkbox.checked = true;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      this._disableButtons();
    }
  }, {
    key: "updateFromCheckbox",
    value: function updateFromCheckbox(e) {
      if (e.target.checked) {
        this.quantitySelectorEl.value = e.target.value;
      } else {
        this.quantitySelectorEl.value = 1;
      }
      var myEvent = new CustomEvent('QUANTITY_UPDATED');
      this.quantitySelectorEl.dispatchEvent(myEvent);
      this.updateCheckbox();
      this._disableButtons();
    }
  }, {
    key: "_getClosestValue",
    value: function _getClosestValue(inputValue) {
      var values = this.values.filter(function (element) {
        return element <= inputValue;
      });
      if (values.length === 0) {
        return null;
      }
      return Math.max.apply(Math, _toConsumableArray(values));
    }
  }, {
    key: "_disableButtons",
    value: function _disableButtons() {
      switch (this.quantitySelectorEl.value) {
        case this.min:
          this.querySelectorButtonsEl[0].disabled = true;
          this.querySelectorButtonsEl[1].disabled = false;
          break;
        case this.max:
          this.querySelectorButtonsEl[0].disabled = false;
          this.querySelectorButtonsEl[1].disabled = true;
          break;
        default:
          this.querySelectorButtonsEl[0].disabled = false;
          this.querySelectorButtonsEl[1].disabled = false;
      }
    }
  }]);
}();